var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"logo",attrs:{"href":"https://www.byggbranschensyrkesnamnd.se/","target":"_blank"}},[_c('v-icon',{attrs:{"size":"100"}},[_vm._v("$sl-logo")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }